<template>
  <div class="">
    <div class="neiye_banner">
      <BANNER></BANNER>
    </div>
    <div class="main">
      <div class="container">
        <div class="location">
          <router-link to="/">网站首页</router-link>
          <router-link to="/ylts/home">&nbsp;&gt;&nbsp;医疗特色</router-link>
          <router-link to="/ylts/home">&nbsp;&gt;&nbsp;科室介绍</router-link>
          <span>&nbsp;&gt;&nbsp;{{ ksName }}</span>
        </div>
        <div class="tv_main clearfix">
          <div class="sjhy_main_left fl">
            <SLIDE></SLIDE>
          </div>
          <div class="sjmy_main_right fr">
            <div
              id="collapse1"
              class="panel-collapse chen_collapse collapse in"
              role="tabpane1"
              aria-labelledby="heading1"
              aria-expanded="true"
              style=""
            >
              <div class="panel-body">
                <div class="sjmy_main_list">
                  <ul class="ksjs">
                    <li v-for="(item, index) in list" :key="index">
                      <span class="ksjs_name" @click="getdoctorList(item)">{{
                        item.name
                      }}</span>
                      <span class="ksjs_list">
                        <b
                          v-for="(detail, n) in item.children"
                          :key="n"
                          @click="getdoctorList(detail)"
                        >
                          {{ detail.name }}
                        </b>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from "../../service/ylts";
import BANNER from "../../components/banner/ylts";
export default {
  name: "KESHIlIST",
  props: {},
  data() {
    return {
      list: [],
      doctorListData: [],
      dialogKsname: "",
      ksName: "",
    };
  },
  components: { BANNER },
  methods: {
    gomingyi(item) {
      let articleId = item.id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/kslist/${articleId}`,
      });
      window.open(href, "_self");
    },
    getKsList(id) {
      service.getKsTree({}, (res) => {
        res.children.map((item) => {
          if (item.id == id) {
            this.ksName = item.name;
            this.list = item.children;
          }
        });
      });
    },
    getdoctorList(e) {
      let articleId = e.id;
      const { href } = this.$router.resolve({
        path: `/ylts/kslist/article/${articleId}`,
      });
      window.open(href, "_self");
    },
    godoctor(id) {
      let articleId = id;
      const { href } = this.$router.resolve({
        path: `/ylts/mingyi/doctor/${articleId}`,
      });
      window.open(href, "_self");
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getKsList(this.$route.params.id);
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.ibox {
  min-height: 120px;
}
</style>
